import featureNames from 'constants/feature_names';

angular.module('gym.dashboard', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.dashboard', {
    url: '/dashboard?freemium_alert',
    controller: 'GymDashboardCtrl',
    template: require('templates/gyms/dashboard/dashboard.html.slim'),
    reloadOnSearch: false,
    resolve: {
      user: function() {
        return window.currentUser;
      },
      permissions: ["EmploymentService", function(EmploymentService) {
        return EmploymentService.get().permissions;
      }]
    }
  }).state('gym.activity', {
    url: '/log_entries',
    template: require('templates/gyms/dashboard/activity.html.slim')
  }).state('gym.dashboard_reports', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.dashboard_reports.absent_attendances', {
    url: '/absent_attendances',
    template: require('templates/gyms/reports/attendance/absent_attendances.html.slim')
  }).state('gym.dashboard_reports.checked_in_attendances', {
    url: '/checked_in_attendances',
    template: require('templates/gyms/reports/attendance/checked_in_attendances.html.slim')
  }).state('gym.dashboard_reports.active_members', {
    url: '/active_contacts?section&period&type&memberInclusion&dashletId&statuses&leadTime&tooltipPeriod',
    template: require('templates/gyms/reports/active_contacts.html.slim')
  }).state('gym.dashboard_reports.net_revenues', {
    url: '/net_revenues?from',
    template: require('templates/gyms/reports/net_revenue.html.slim')
  }).state('gym.dashboard_reports.monthly_run_rates', {
    url: '/monthly_run_rates?from',
    template: require('templates/gyms/reports/monthly_run_rates.html.slim')
  });
}]).controller('GymDashboardCtrl', ["$scope", "$state", "$stateParams", "$location", "$http", "$window", "DashboardPrivacyModeService", "loadingAnimation", "GTMService", "ReactModal", "MessageService", "gym", "Dashboard", "user", "permissions", function($scope, $state, $stateParams, $location, $http, $window, DashboardPrivacyModeService, loadingAnimation, GTMService, ReactModal, MessageService, gym, Dashboard, user, permissions) {
  var isWidgetVisible, messageParams;
  $scope.gym = gym.attributes;
  $scope.isV2DashboardAvailable = $scope.gym.gym_config.v2_dashboard_available;
  $scope.user = user;
  $scope.permissions = permissions;
  $scope.privacyModeEnabled = DashboardPrivacyModeService.isEnabled();
  $scope.featureNames = featureNames;
  $scope.dashboardVersion = null;
  $scope.dashlets = [];
  $scope.dashboardV2View = 'dashboard';
  $scope.dashletRefreshTimestamp = null;
  $scope.cachedDataRefreshKey = 0;
  $scope.onCachedDataRefreshed = function() {
    return $scope.cachedDataRefreshKey += 1;
  };
  GTMService.trackPage('Dashboard');
  $scope.isAccountOwner = window.currentUser.account_owner;
  $scope.isDashboardV2GeneralOptInAvailable = $scope.gym.gym_dashboard_detail.v2_dashboard_opt_in_generally_available;
  $scope.setV2DashboardView = function(view) {
    return $scope.dashboardV2View = view;
  };
  $scope.setIsDashboardV2GeneralOptInAvailable = function(value) {
    return $scope.isDashboardV2GeneralOptInAvailable = value;
  };
  $scope.getDashboardVersion = function() {
    var url;
    url = `/gyms/${$scope.gym.id}/dashboard/user_settings`;
    return $http.get(url).then(function(response) {
      $scope.dashboardVersion = response.data.dashboard_version;
      if ($scope.dashboardVersion === 'v2_dashboard_design') {
        return $scope.getDashboardDashlets();
      }
    });
  };
  $scope.getDashboardDashlets = function() {
    var url;
    loadingAnimation.show();
    url = `/gyms/${$scope.gym.id}/dashlets/for_dashboard`;
    return $http.get(url).then(function(response) {
      $scope.dashlets = response.data;
      $scope.dashletRefreshTimestamp = $scope.dashlets.reduce(function(earliest, current) {
        if (new Date(current.cached_at) < new Date(earliest.cached_at)) {
          return current;
        } else {
          return earliest;
        }
      }, $scope.dashlets[0]);
      return loadingAnimation.hide();
    });
  };
  $scope.getDashboardVersion();
  $scope.checkAndGetDashboardDashlets = function() {};
  if ($scope.dashboardVersion === 'v2_dashboard_design') {
    $scope.getDashboardDashlets();
  }
  $scope.openDashboardV2PromptModal = function() {
    return ReactModal.open({
      component: 'DashboardV2PromptModal',
      props: {
        isDashboardV2GeneralOptInAvailable: $scope.isDashboardV2GeneralOptInAvailable
      }
    }).then(function() {
      return $scope.getDashboardVersion();
    });
  };
  isWidgetVisible = function(widget) {
    var key;
    key = widget === 'recent_activity' ? `show_${widget}` : `show_${widget}_dashlet`;
    switch ($scope.gym.gym_dashboard_detail[key]) {
      case `show_${widget}_for_all_users`:
        return true;
      case `hide_${widget}_for_all_users`:
        return false;
      case `show_${widget}_for_owners_only`:
        return window.currentUser.account_owner;
    }
  };
  if ($stateParams.freemium_alert) {
    messageParams = {
      title: 'You are now on the Clubworx Free plan',
      message: ["Woops! It looks like your account's free trial has expired, and you did not choose a subscription plan.", `We've changed your account over to the Free plan, which means you can keep using our basic features for as long as you like. However, you'll be missing out on some of what makes Clubworx special, like ${featureNames.SEQUENCE_PLURAL}, Waiver Forms and Workout Management!`, "To learn more about subscription options and the other features Clubworx offers, click the \"Tell me more\" button below, or visit the My Subscription page any time."],
      confirmButtonText: 'Tell me more',
      cancelButtonText: 'Close'
    };
    MessageService.message(messageParams).then(function() {
      var url;
      url = $state.href('gym.subscription.tab', {
        tab: 'subscriptions'
      });
      return $window.open(url, '_self');
    }, function() {
      return $location.search('freemium_alert', void 0);
    });
  }
  $scope.disablePrivacyMode = function() {
    DashboardPrivacyModeService.set(false);
    loadingAnimation.show();
    return $window.location.reload();
  };
  $scope.activeMembersWidgetAvailable = $scope.permissions.view_contact_report && isWidgetVisible('active_members');
  $scope.attendanceWidgetAvailable = $scope.permissions.view_attendance_report && isWidgetVisible('attendance');
  $scope.netRevenueWidgetAvailable = $scope.permissions.view_revenue_report && isWidgetVisible('net_revenue');
  $scope.monthlyRevenueWidgetAvailable = $scope.permissions.view_revenue_report && isWidgetVisible('monthly_revenue');
  $scope.recentActivityWidgetAvailable = $scope.permissions.view_activity_stream && isWidgetVisible('recent_activity');
  $scope.taskWidgetAvailable = $scope.permissions.manage_tasks && isWidgetVisible('tasks');
  $scope.isReportsAvailable = function() {
    return $scope.activeMembersWidgetAvailable || $scope.attendanceWidgetAvailable || $scope.netRevenueWidgetAvailable || $scope.monthlyRevenueWidgetAvailable || $scope.recentActivityWidgetAvailable;
  };
  $scope.goToContacts = function(contactType) {
    return $state.go('gym.contacts.list', {
      contactType: contactType
    });
  };
  $scope.setLastRefreshedTimestamp = function(timestamp) {
    return $scope.lastRefreshedTimestamp = timestamp;
  };
  return $scope.refresh = function() {
    if ($scope.refreshing) {
      return;
    }
    $scope.refreshing = true;
    return Dashboard.doPOST({}, 'refresh_cache').then(function() {
      $scope.refreshing = false;
      return $scope.$broadcast('dashboard:refresh');
    }, function() {
      return $scope.refreshing = false;
    });
  };
}]);
